// no define property meant for dynamic purpose only
const getDefaultState = (() => ({ }));

export default {
    namespaced: true,

    state: getDefaultState(),

    getters: {
        // fetch any keys from vuex
        get: state => key => state[key],
    },

    mutations: {
        SET(state, data)
        {
            state[data.key] = data.value;
        },

        REMOVE(state, key)
        {
            state[key] = null;
        },
        
        RESET_STATE (state) {
            // Merge rather than replace so we don't lose observers
            // https://github.com/vuejs/vuex/issues/1118
            Object.keys(state).forEach(key => {
                delete state[key];
            });
        }
    },

    actions: {},
};
